import { Deferred } from 'everyday-utils'
import { DsplNode } from './dspl-node'
import { createMemory } from './frontend'
import { PreviewWorkerMessagePayload } from './preview-worker'
import { post } from './util'
import { Param } from './producer'

export type PreviewServiceMessagePayload =
  | { onReady: true }
  | { onPreview: true, id: string, outs: [Float32Array, Float32Array] }
  | { onError: true, id: string, error: any }

export interface PreviewService {
  onReady?(): void
  onPreview?(id: string, outs: [Float32Array, Float32Array]): void
  onError?(id: string, error: any): void
  render(id: string, code: string, param?: Param | false): Promise<void>
}

export const previews: Map<string, Deferred<[Float32Array, Float32Array]>> = new Map()

const previewServices: Map<number, Deferred<PreviewService>> = new Map()

export async function createPreviewService(length: number) {
  let deferred = previewServices.get(length)

  if (deferred) {
    return deferred.promise
  }

  deferred = Deferred()
  previewServices.set(length, deferred)

  const url = new URL('./preview-worker.js', import.meta.url).href
  const worker = new Worker(url)

  const memory = createMemory()

  post<PreviewWorkerMessagePayload>(worker, {
    init: [DsplNode.vmBinary, memory, length]
  })

  const service: PreviewService = {
    async render(id: string, code: string, param?: Param | false) {
      await deferred!.promise
      post<PreviewWorkerMessagePayload>(worker, {
        render: [id, code, param]
      })
    }
  }

  worker.onmessage = (e: MessageEvent<PreviewServiceMessagePayload>) => {
    if ('onReady' in e.data) {
      deferred!.resolve(service)
      service.onReady?.()
    }
    else if ('onPreview' in e.data) {
      service.onPreview?.(e.data.id, e.data.outs)
    }
    else if ('onError' in e.data) {
      service.onError?.(e.data.id, e.data.error)
    }
  }

  return deferred.promise
}
